import axios from 'axios';
import host from '../global';
import Cookies from 'js-cookie';

// Browser-triggered analytics events go through the backend, which adds the
// standard properties and checks (see backend/app/services/analytics_service.py).
// Fire-and-forget: analytics must never get in the way of the page.
export const postAnalyticsEventService = (event, data = {}) =>
  axios
    .post(
      `${host}/api/analytics/event`,
      { event, ...data },
      { headers: { Authorization: `Bearer ${Cookies.get('accessToken')}` } },
    )
    .catch(() => {});
